var map = {
	"./en/button.json": [
		1073,
		73
	],
	"./en/menu.json": [
		3943,
		943
	],
	"./en/page.json": [
		7938,
		938
	],
	"./fr/button.json": [
		3607,
		413
	],
	"./fr/menu.json": [
		1388,
		388
	],
	"./fr/page.json": [
		9627,
		627
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 8140;
module.exports = webpackAsyncContext;